<template>
  <div class="animated fadeIn">
    <b-card header="메뉴 등록">
      <b-form v-on:submit.prevent="submitHandling">
        <b-form-group
                label="메뉴 이름"
                label-for="menu-name"
                horizontal>
          <b-form-input id="menu-name"
                        v-model="menuDto.menuName"
                        class="d-inline-block w-50" placeholder="메뉴 이름을 입력해주세요."></b-form-input>
        </b-form-group>

        <b-form-group
                label="메뉴 타이틀 여부"
                label-for="menu-title"
                horizontal>
          <b-form-checkbox id="menu-title"
                           v-model="menuDto.titleYn"
                           :value="true"
                           :unchecked-value="false" @change="resetUpperId">
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
                label="상위메뉴 선택"
                label-for="upper-menu"
                horizontal v-show="menuDto.titleYn === false">
          <div class="vSelectWrapper">
            <v-select v-model="upperMenu" @input="upperMenuSelectHandling" id="upper-menu" label="menuName" :options="upperMenuList" placeholder="그룹 이름을 입력해주세요." required>
              <template slot="no-options">검색 결과가 없습니다.</template>
              <!--<template slot="option" slot-scope="option">-->
                <!--<span :class="option.icon"></span>-->
                <!--{{ option.title }}-->
              <!--</template>-->
            </v-select>
          </div>
        </b-form-group>

        <!--<b-form-group-->
                <!--label="메뉴 링크"-->
                <!--label-for="menu-url"-->
                <!--horizontal v-show="menuDto.titleYn === false">-->
          <!--<b-form-input id="menu-url"-->
                        <!--v-model="menuDto.url"-->
                        <!--class="d-inline-block w-50" placeholder="메뉴 링크를 입력해주세요."></b-form-input>-->
        <!--</b-form-group>-->

        <b-form-group
                label="메뉴 경로"
                label-for="menu-url"
                horizontal>
          <b-form-input id="menu-url"
                        v-model="menuDto.url"
                        class="d-inline-block w-50" placeholder="메뉴 경로를 입력해주세요."></b-form-input>
        </b-form-group>

        <b-form-group
                label="메뉴 아이콘"
                label-for="menu-icon"
                horizontal>
          <b-form-input id="menu-icon"
                        v-model="menuDto.icon"
                        class="d-inline-block w-50" placeholder="메뉴 아이콘을 입력해주세요."></b-form-input>
        </b-form-group>
        <b-button type="submit">등록</b-button>
      </b-form>
    </b-card>
  </div>
</template>
<script>
  import AuthService from '@/common/api/auth.service'
  import { mapMutations } from 'vuex'
  import { SHOW_MODAL } from '@/store/ui/mutations.type'
  import { $showModalWithErrorMsg } from '@/common/util'
  export default {
    data () {
      return {
        upperMenu: null,
        upperMenuList: [
          {
            menuName:'없음',
            url: '',
            upperId: 0,
            menuId: 0
          },
        ],
        menuDto: {
          upperId: 0,
          menuName: '',
          url: '',
          icon: '',
          titleYn: true
        }
      }
    },
    mounted () {
      AuthService.getUpperMenuList()
        .then(({data})=> {
          this.upperMenuList = [...this.upperMenuList, ...data]
        })
        .catch($showModalWithErrorMsg.bind(this))
    },
    methods: {
      upperMenuSelectHandling (val) {
        if (val !== null) {
          this.menuDto.upperId = val.menuId
        }
      },
      submitHandling () {
        AuthService.createMenu(this.menuDto)
          .then(() => {
            this[SHOW_MODAL]({msg: '메뉴를 등록하였습니다.', okHandling: () => {}})
          })
          .catch($showModalWithErrorMsg.bind(this))
      },
      resetUpperId () {
        this.menuDto.upperId = 0
        this.menuDto.url = ''
        this.upperMenu = null
      },
      ...mapMutations('ui', [SHOW_MODAL])
    }
  }
</script>
<style scoped>
  .vSelectWrapper .dropdown-toggle:after {
    display: none !important;
  }
</style>
